import React from 'react'

type ColorType = 'success'

interface LabelProps {
  id: string
  label: string
  isVisible: boolean
  colorType?: ColorType
}

const Label = ({ id, label, isVisible, colorType }: LabelProps): JSX.Element => (
  isVisible
    ? <div id={id} className={`flex justify-center items-center text-sm ${colorType === 'success' ? 'text-green-600' : 'text-black'}`}> { label }</div>
    : <></>
)

export default Label
